import React from 'react';
import { Container, Table } from 'react-bootstrap';

const PaginasPublicas: React.FC = () => {
  const publicPages = [
    { path: '/historico/candidatos', description: 'Histórico de Candidatos' },
    { path: '/emails/confirmacao', description: 'Confirmação de Email' },
    { path: '/recursos/candidato', description: 'Formulário de Recurso' },
    { path: '/recurso', description: 'Formulário de Recurso (alias)' },
    { path: '/candidato', description: 'Acesso à Sala do Candidato' },
    { path: '/verificacao', description: 'Verificação de Documento' },
    { path: '/verificacao/:codigo', description: 'Verificação de Documento (com código)' },
    { path: '/login', description: 'Login' },
  ];

  const baseUrl = window.location.origin;

  return (
    <Container className="mt-4">
      <h2>Páginas Públicas</h2>
      <p className="text-muted">URLs das páginas públicas disponíveis no sistema</p>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Descrição</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          {publicPages.map((page, index) => (
            <tr key={index}>
              <td>{page.description}</td>
              <td>
                <a href={`${baseUrl}${page.path}`} target="_blank" rel="noopener noreferrer">
                  {baseUrl}{page.path}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default PaginasPublicas;
